import { Container, StyledPlayIcon } from "./styles";

export const VideoPlayIcon = () => (
  <Container>
    <StyledPlayIcon />
  </Container>
);

VideoPlayIcon.displayName = "VideoPlayIcon";
